const t = "af.favorite", s = class s extends CustomEvent {
  constructor() {
    super(t, { bubbles: !0, composed: !0 });
  }
};
s.EVENT_NAME = t;
let e = s;
export {
  t as EVENT_NAME,
  e as default
};
//# sourceMappingURL=FavoriteEvent.js.map
